// extracted by mini-css-extract-plugin
module.exports = {"seo-text":"_93444fe79c--seo-text--kIV3Y","seoText":"_93444fe79c--seoText--mxheU"};